<template>
    <b-container>
        <Breadcrumbs crumbString="Products"></Breadcrumbs>
        <b-row>
            <b-col>
                <h2>{{ title }}</h2>
                <div>
                  enviroSIGNS offers a complete capability related to development of interpretive,
                  historical, and commemorative signage. We use time-tested products that work. In addition, we provide
                  frames, mountings, kiosks, bulletin cases, and site amenities.
                    <ul>
                        <li><router-link :to="{ name: 'graphic-panels' }">Graphic Panels</router-link></li>
                        <li><router-link :to="{ name: 'mountings' }">Mountings</router-link></li>
                        <li><router-link :to="{ name: 'story-walk' }">Story-walk Frames & Bases</router-link></li>
                        <li><router-link :to="{ name: 'routed-plastic' }">Routed Plastic Signs & Recycled Plastic Posts</router-link></li>
                        <!-- <li><router-link :to="{ name: 'site-amenities' }">Recycled Plastic Site Amenities</router-link></li> -->
                        <li><router-link :to="{ name: 'specialty-items' }">Specialty Items</router-link></li>
                    </ul>
                </div>
                <div><b-btn @click="createEstimateFromPage">Create an Estimate</b-btn></div>
            </b-col>
            <b-col class="col-12 col-md-8 col-lg-8">
                <b-container class="pods-container">
                    <b-row>
                        <b-col class="col-12 col-md-8 col-lg-8 image-pod">
                          <router-link :to="{ name: 'graphic-panels' }">
                            <div class="img product-img-200"
                                 v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/products/interpretive-graphic-panels.jpg') + ')'}"></div>
                            <span>Graphic Panels</span>
                          </router-link>
                        </b-col>
                        <b-col class="col-12 col-md-4 col-lg-4 image-pod">
                          <router-link :to="{ name: 'mountings' }">
                            <div class="img product-img-201"
                                 v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/products/interpretive-mountings.jpg') + ')'}"></div>
                            <span>Mountings</span>
                          </router-link>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-12 col-md-6 col-lg-6">
                            <b-row>
                                <b-col class="col-12 col-md-12 col-lg-12 image-pod">
                                  <router-link :to="{ name: 'specialty-items' }">
                                    <div class="img product-img-115"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/products/specialty-items.jpg') + ')'}"></div>
                                    <span>Specialty Items</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="col-12 col-md-12 col-lg-12 image-pod">
                                  <router-link :to="{ name: 'routed-plastic' }">
                                    <div class="img product-img-220"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/products/routed-recycled-plastic-signs-and-posts.jpg') + ')'}"></div>
                                    <span>Routed Plastic Signs & Posts</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col>
                            <b-row>
                                <b-col class="col-12 col-md-12 col-lg-12 image-pod">
                                  <router-link :to="{ name: 'story-walk' }">
                                    <div class="img product-img-240"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/products/storywalk-frames-and-posts.jpg') + ')'}"></div>
                                    <span>Storywalk Frames & Posts</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="col-12 col-md-6 col-lg-6 image-pod">
                                  <!-- <router-link :to="{ name: 'site-amenities' }">
                                    <div class="img product-img-98"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/products/recycled-plastic-site-amenities.jpg') + ')'}"></div>
                                    <span>Site Amenities</span>
                                  </router-link> -->
                                </b-col>
                                <b-col></b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
  import Breadcrumbs from '../Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'Products'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Products.vue